/**
 * FolderIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const FolderIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M1 18a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3h-8.67l-.74-1.11A2 2 0 0 0 8.93 3H3a2 2 0 0 0-2 2zm20 0a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8.5A1.5 1.5 0 0 1 4.5 7H20a1 1 0 0 1 1 1z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const FolderIcon = makeIcon('FolderIcon', FolderIconSvg)
